import { defineComponent as _defineComponent } from 'vue'
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import RemoveAds from '@/components/buybox-new/RemoveAds.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromotionRowCTA',
  props: {
    isHighlighted: { type: Boolean },
    hasPromotionTag: { type: Boolean },
    showRemoveAdsBtn: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	isHighlighted: boolean;
	hasPromotionTag?: boolean;
	showRemoveAdsBtn?: boolean;
};



const hasFootnote = computed(() => {
	// If promotion row has both RemoveAds and PromotionTag, we place them both in a third grid row in PromotionRowNew
	// Otherwise we place the indiviual element below the CTA button
	if (props.showRemoveAdsBtn) return !props.hasPromotionTag;

	return props.hasPromotionTag;
});

return { __sfc: true,props, hasFootnote, faPlay, RemoveAds }
}

})